var React = require('react');

function ChevronRight2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.32372 13L7 7.25771L1.32372 1.51543","strokeWidth":"1.5"}));
}

ChevronRight2.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = ChevronRight2;

ChevronRight2.default = ChevronRight2;
